import * as React from 'react';
import { withTranslation  } from 'react-i18next';
import { connect } from 'react-redux';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as AlertModule from 'Modules/AlertModule';
import * as FleetModule from 'Modules/FleetModule';
import * as HistoryModule from 'Modules/HistoryModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as Dictionary from 'Models/Dictionary';
import {AlertBlock, AlertHistoryBlock, createArrayOfPoints, DateTimeComponent} from './_CompositesHelpers';
import { createSerachQuery } from 'Connectors/_main';
import SearchHistoryLogAlerts from 'components/Layout/Form/SearchHistoryLogAlerts';
import MarkerClusterGroup from "react-leaflet-markercluster";
import {Marker, Polyline, Popup} from "react-leaflet";
import moment from "moment";
import * as L from "leaflet";
import * as MapModule from "Modules/MapModule";

type P = {
    title: string;
    disabled?: boolean;
    history: any;
    zone?: HistoryModule.EnumTypes.CarDetailsViewType;
};

type S = {
    activeView: 'HISTORY' | 'ASSIGNED';
};
type DispatchedP = {
    getUsersAlertsWithLoaderSmall: (params?: URLSearchParams) => void;
    getAlertHistoryLog: (params?: URLSearchParams) => void;
    clearHistoryLog: () => void;
    showAlerts: () => void;
    setMapCenter: Function;
};
type ConnectedP = {
    t?: (key: string) => string;
    vehiclesStore: VehiclesModule.Types.VehiclesStore;
    fleetStore: FleetModule.Types.FleetStore;
    alertStore: AlertModule.Types.AlertStore;
};
class Alerts extends React.Component<P & DispatchedP & ConnectedP, S> {
    constructor(props: P & DispatchedP & ConnectedP) {
        super(props);
        this.state = {
            activeView: 'HISTORY'
        };
        this.searchHistoryLogAlerts = this.searchHistoryLogAlerts.bind(this);
    }
    public shouldComponentUpdate(nextProps: P & ConnectedP & DispatchedP) {
        if (nextProps.vehiclesStore.activeVehicleDetails) {
            if (this.props.vehiclesStore.activeVehicleDetails.id !== nextProps.vehiclesStore.activeVehicleDetails.id) {
                this.groupAlerts();
                this.props.clearHistoryLog();
            }
        }

        return true;
    }
    public async groupAlerts() {
        const { getUsersAlertsWithLoaderSmall, vehiclesStore } = this.props;
        if(vehiclesStore.activeVehicleDetails) {
            const carFilter = {
                carId: vehiclesStore.activeVehicleDetails.id
            };
            const params = createSerachQuery(carFilter);
            await getUsersAlertsWithLoaderSmall(params);
        }
    }
    public async componentDidMount() {
        await this.groupAlerts();
    }
    private async searchHistoryLogAlerts(formData: any) {
        const { getAlertHistoryLog } = this.props;
        formData.carId = this.props.vehiclesStore.activeVehicleDetails.id;
        const searchQuery = createSerachQuery(formData);
        await getAlertHistoryLog(searchQuery);
        this.props.showAlerts();
    }

    private gotoSelectAlertOnMap(_lat, _lng) {
        this.props.setMapCenter({lat: _lat, lng: _lng});
    }

    public render() {
        const { t, alertStore } = this.props;
        const { activeView } = this.state;
        return (
            <div className="alerts">
                <div className="alerts__head">
                    <div className="btn-set__options">
                        <div className={`btn-set__single ${activeView === 'HISTORY' ? 'btn-set__single--active' : ''}`} onClick={() => this.setState({ activeView: 'HISTORY' })}>
                            {t('history')}
                        </div>
                        <div className={`btn-set__single ${activeView === 'ASSIGNED' ? 'btn-set__single--active' : ''}`} onClick={() => this.setState({ activeView: 'ASSIGNED' })}>
                            {t('assigned')}
                        </div>
                    </div>
                    <div className="alerts__head-btn btn btn--blue" onClick={() => this.props.history.push(`${Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.ALERTS)}/add`)}>
                        {t('add')}
                    </div>
                </div>
                {activeView === 'ASSIGNED' && (
                    <div className="alerts__group">
                        <AlertBlock title={t('info')} iconSrc={'/images/icons/priority_blue.svg'} alertList={alertStore.alertDefinitionGroupped.LOW} t={this.props.t} />
                        <AlertBlock title={t('warnings')} iconSrc={'/images/icons/priority_yellow.svg'} alertList={alertStore.alertDefinitionGroupped.MEDIUM} t={this.props.t} />
                        <AlertBlock title={t('alerts')} iconSrc={'/images/icons/priority_red.svg'} alertList={alertStore.alertDefinitionGroupped.HIGH} t={this.props.t} />
                    </div>
                )}
                {activeView === 'HISTORY' && (
                    <>
                        <div className="alerts__element">
                            <SearchHistoryLogAlerts onSubmit={this.searchHistoryLogAlerts} />
                        </div>
                        {this.props.alertStore.alertHistoryLog && this.props.alertStore.alertHistoryLog.results.length === 0 && (
                            <div className="alerts__element">
                                <p>{t('noHistoryAlertData')}</p>
                            </div>
                        )}
                        <div className="alerts__group alerts__group--history">
                            {this.props.alertStore.alertHistoryLog && this.props.alertStore.alertHistoryLog.results.map((e, i) => <div key={`historyAlert-${i}`} onClick={()=> this.gotoSelectAlertOnMap(e.carDataframe.latitude, e.carDataframe.longitude) }> <AlertHistoryBlock alert={e} /> </div>)}
                        </div>
                    </>
                )}
            </div>
        );
    }
}

const createClusterCustomIcon = function(cluster: L.MarkerCluster) {
    return L.divIcon({
        html: `<div class="count-container">
                    <img class="car-ImgEl" src="/images/icons/alert.svg">
                    <span class="count-container__count-value">${cluster.getChildCount()}</span>
               </div>`,
        className: `marker-cluster__stop-sign`,
        iconSize: L.point(40, 40, true)
    });
};

export class SummaryAlertsRender extends React.Component<any> {

    constructor(props: AlertModule.Types.PaginatedListAlertHistoryLogDto) {
        super(props);
    }

    public render() {
        const { results } = this.props.alertHistoryLog;
        if (results !== null && typeof results!== 'undefined') {
            return (
                <MarkerClusterGroup iconCreateFunction={createClusterCustomIcon}>
                    {results.map((singleAlert, idx) => <PopupAlertDetails key={idx} singleAlert={singleAlert} /> )}
                </MarkerClusterGroup>
            );
        }
        return null;
    }
}

const PopupAlertDetails = (props: { singleAlert: AlertModule.Types.AlertHistorySingleLogDto }) => {
    const { carDataframe, title, message} = props.singleAlert;
    const position = {
        lat: carDataframe.latitude,
        lng: carDataframe.longitude
    };
    const [popupVisible, setPopupVisibility] = React.useState(false);


    const alertDate = moment(carDataframe.dateTime);
    const html = `<p class="vehicle-icon__title activeCar">
                      <span class="car-Name">${alertDate.format("HH:mm:ss")}</span>
                      </br>
                      <span class="car-DeviceId">${alertDate.format("DD.MM.YYYY")}</span>
                  </p>
                  <div class="car-Img">
                    <img class="car-ImgEl" src="/images/icons/alert.svg">
                  </div>`;

    const Icon = L.divIcon({
        iconUrl: '/images/icons/alert.svg',
        iconSize: [25,25],
        html,
        className: `vehicle-icon vehicle-icon--hover`
    });

    return (
        <>
            <Marker
                position={position}
                icon={Icon}
                onClick={() => setPopupVisibility(!popupVisible)} />

            {popupVisible &&
                <Popup className="pathpoint_popup_details" position={position} autoPan={false}>
                    <div className="pathpoint_popup_details__data">
                        <img src={'/images/icons/alert.svg'} width={20} className={'icon-vertical-bottom pr-5'}/>
                        <span className="font-bold">
                            {title}
                        </span>

                        <div className="text-right">
                            <DateTimeComponent date={carDataframe.dateTime} />
                            <div>
                                {carDataframe.address && carDataframe.address.addressDisplayName}
                            </div>
                        </div>
                        <p className="font-sm mt-20">
                            <span className="font-bold">
                                {message}
                            </span>
                        </p>
                    </div>
                </Popup>
            }
        </>
    );
};

function mapStateToProps(state: any): ConnectedP {
    return {
        vehiclesStore: state.vehiclesStore,
        fleetStore: state.fleetStore,
        alertStore: state.alertStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        getUsersAlertsWithLoaderSmall: (params?: URLSearchParams) => dispatch(AlertModule.Actions.getUsersAlertsWithLoaderSmall(params)),
        getAlertHistoryLog: (params?: URLSearchParams) => dispatch(AlertModule.Actions.getAlertHistoryLog(params)),
        clearHistoryLog: () => dispatch(AlertModule.Actions.clearHistoryLog()),
        showAlerts: () => dispatch(ViewManagementModule.Actions.showAlerts()),
        setMapCenter: (center: MapModule.Types.MapCenter) => dispatch(MapModule.Actions.setMapCenter(center))
    };
}
export default withTranslation ('carDetails')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(Alerts) as React.ComponentType<any>
) as React.ComponentClass<P>;



// WEBPACK FOOTER //
// ./src/components/Map/CarDetails/Composites/Alerts.tsx